class PredictiveSearchRecomm extends HTMLElement {
    constructor() {
        super();

        // this.searchContainer = document.querySelector('#global__predictive_search');
        this.openButton = document.querySelector('#open_search_recomm_form');
        this.closeButton = this.querySelector('#close_search_recomm_form');
        this.searchInput = this.querySelector('#Search-recomm');
        this.resetButton = this.querySelector('#reset_search_recomm');

        this.initialData = this.parseSectionData(document);
        this.latestData = this.initialData;

        if (this.openButton) {
            this.openButton.addEventListener('click', (event) => {
                event.preventDefault();
                this.showSearchForm();
            });
        }

        if (this.resetButton) {
            this.resetButton.addEventListener('click', (event) => {
                event.preventDefault();
                this.resetSearch();
            });
        }

        this.addEventListener('keydown', k => {
            if (k.key == 'Escape') {
                k.preventDefault();
                this.closeButton.focus();
            }
        });
        this.searchInput.addEventListener('focus', event => {
            const searchTerm = this.searchInput.value.trim();
            this.handleQuery(searchTerm);
        });
        this.searchInput.addEventListener('input', this.debounce(this.onInput.bind(this), 400));
        this.applyTemplate(this.initialData);

        // Inserting the recommended searches:
        const recommSearchesData = document.querySelector('#predictive-search-recomm-search-terms');
        if (recommSearchesData) {
            let recommSearchesJson = {};
            try {
                recommSearchesJson = JSON.parse(recommSearchesData.textContent);
            } catch (e) {
                console.error('Failed to parse recommended searches JSON', e);
            }
            
            const arrRecommSearches = Array.isArray(recommSearchesJson.recomm_searches) ? recommSearchesJson.recomm_searches : [];
            const topSearchTemplate = this.querySelector('#recomm_searches');
            const topSearchesUl = this.querySelector('.top-searches-terms');
            if (topSearchTemplate && topSearchesUl) {
                const baseSearchUrl = this.searchInput?.form?.action || '/search';
                const fragment = document.createDocumentFragment();
                arrRecommSearches.forEach(term => {
                    const clone = topSearchTemplate.content.cloneNode(true);
                    const listItem = clone.querySelector('li');
                    const link = listItem.querySelector('a');
                    const svg = link.querySelector('svg');
                    link.innerHTML = '';
                    if (svg) link.append(svg);
                    link.append(term);
                    link.href = `${baseSearchUrl}?q=${encodeURIComponent(term)}`;
                    fragment.appendChild(listItem);
                });
                topSearchesUl.appendChild(fragment);
            }
        }
    }

    onInput(event) {
        this.handleQuery(event.target.value);
    }

    handleQuery(query) {
        const searchTerm = query.trim();

        if (!searchTerm.length) {
            this.latestData = this.initialData;
            this.applyTemplate(this.latestData);
        } else {
            this.getSearchResults(searchTerm)
                .then(json => {
                    this.latestData = json;
                    this.applyTemplate(this.latestData);
                });
        }
    }

    getSearchResults(searchTerm) {
        const encodedTerm = encodeURIComponent(searchTerm);
        const url = `/search/suggest?q=${encodedTerm}&resources[type]=product&resources[limit]=4&section_id=predictive-search-recomm`;

        return fetch(url)
            .then((response) => {
                if (!response.ok) {
                    throw new Error(response.status);
                }

                return response.text();
            })
            .then((text) => {
                const doc = new DOMParser().parseFromString(text, 'text/html');
                const dataElement = doc.querySelector('#predictive-search-recomm-data');

                if (!dataElement) {
                    throw new Error('Predictive search recommendation data not found');
                }

                return JSON.parse(dataElement.textContent);
            })
            .catch((error) => {
                console.error('Predictive search recommendation request failed', error);
            });
    }

    parseSectionData(root) {
        const jsonDataElement = root.querySelector('#predictive-search-recomm-data');
        if (!jsonDataElement) return null;

        try {
            return JSON.parse(jsonDataElement.textContent);
        } catch (error) {
            console.error('Failed to parse predictive search JSON data', error);
            return null;
        }
    }

    applyTemplate(json) {
        if (!json) {
            return;
        }
        const arrProducts = Array.isArray(json.recomm_products) ? json.recomm_products : [];
        const heading = this.querySelector('#predictive-search-results-header');
        const topsearches = this.querySelector('#predictive-search-top-searches');
        heading.textContent = json.recomm_header || '';

        const productTemplate = this.querySelector('#recomm_products');
        const productList = this.querySelector('#predictive-search-results-list');

        if (productTemplate && productList) {
            productList.innerHTML = '';
            productList.classList.remove('status_searching', 'status_initial');
            productList.classList.add(json.status);
            topsearches.classList.remove('status_searching', 'status_initial');
            topsearches.classList.add(json.status);

            arrProducts.forEach((product, index) => {
                const clone = productTemplate.content.cloneNode(true);
                const listItem = clone.querySelector('li');
                const link = listItem.querySelector('a');
                const href = product.url;
                link.href = href;

                const imageEl = listItem.querySelector('.predictive-search-recomm__image');
                imageEl.src = product.imgUrl;
                imageEl.alt = product.imgAlt;

                const titleEl = listItem.querySelector('.predictive-search-recomm__title');
                titleEl.textContent = product.title;

                const priceEl = listItem.querySelector('.predictive-search-recomm__price');
                priceEl.textContent = product.price;


                productList.appendChild(listItem);

                // Adding a link to perform the complete search.
                if (index == arrProducts.length - 1) {
                    const searchTerms = json.recomm_terms;
                    if (searchTerms == '') return;
                    const clone = productTemplate.content.cloneNode(true);
                    const listItem = clone.querySelector('li');
                    listItem.classList.add("search-for-link");
                    const imageEl = listItem.querySelector('.predictive-search-recomm__image');
                    imageEl.remove();
                    const priceEl = listItem.querySelector('.predictive-search-recomm__price');
                    priceEl.remove();
                    const link = listItem.querySelector('a');
                    const baseSearchUrl = this.searchInput?.form?.action || '/search';
                    link.href = `${baseSearchUrl}?q=${encodeURIComponent(searchTerms)}`;
                    const titleEl = listItem.querySelector('.predictive-search-recomm__title');
                    titleEl.textContent = `SEARCH FOR "${searchTerms}"`;

                    heading.textContent = `TOP RESULTS FOR "${searchTerms}"`;

                    productList.appendChild(listItem);
                }
            });
        }
    }

    resetSearch() {
        this.searchInput.value = '';
        this.latestData = this.initialData;

        if (this.initialData) {
            this.applyTemplate(this.initialData);
        }

        this.searchInput.focus();
        this.searchInput.select();
    }

    showSearchForm() {
        this.searchInput.focus();
        this.searchInput.select();
    }

    hideSearchForm() {
        if (!this.searchContainer) {
            return;
        }

        // this.searchContainer.setAttribute('is-active', 'false');
    }

    debounce(fn, wait) {
        let timeout;

        return (...args) => {
            clearTimeout(timeout);
            timeout = setTimeout(() => fn.apply(this, args), wait);
        };
    }
}

if (!customElements.get('predictive-search-recomm')) {
    customElements.define('predictive-search-recomm', PredictiveSearchRecomm);
}